/**
 * SchedulingDispatchRoute — always renders the unified Scheduling & Dispatch
 * cockpit. The previous skin-aware switch routed "classic" users to a bare
 * legacy calendar that hid the new Plan/Dispatch lenses, drag-to-reschedule,
 * and ready-job booking. The cockpit is now the canonical surface for this
 * URL regardless of UI skin.
 */
import SchedulingDispatchCockpit from "@/components/dashboards/SchedulingDispatchCockpit";

export default function SchedulingDispatchRoute() {
  return <SchedulingDispatchCockpit />;
}
